import { useLazyLoadQuery } from 'react-relay';
import { graphql } from 'relay-runtime';
import { toGlobalID } from 'src/shared/helpers';
import { useProductSceneQuery } from './__generated__/useProductSceneQuery.graphql';

export function useProductScene(productId: number | undefined): boolean {
    // Always call the hook (Rules of Hooks), using a placeholder ID when no product.
    // When productId is undefined, use 'store-only' to skip the network request entirely.
    const globalId = toGlobalID(productId ?? 0, 'Model');

    const data = useLazyLoadQuery<useProductSceneQuery>(
        graphql`
            query useProductSceneQuery($productId: ID!) {
                model(id: $productId) {
                    id
                    modelID
                    scenes {
                        sceneID
                    }
                }
            }
        `,
        { productId: globalId },
        { fetchPolicy: productId ? 'store-or-network' : 'store-only' }
    );

    if (!productId) return false;

    // Detection logic: product has 3D if it has scenes with a sceneID
    const hasScene = data.model?.scenes && data.model.scenes.length > 0 && data.model.scenes[0].sceneID;

    return !!hasScene;
}
